export function buildBidCreatePayload({endpointId, sellerId}) {
  return {
    endpoint_id: endpointId,
    ...(sellerId != null && {seller_id: sellerId}),
  }
}
